import React from "react";
import MainMenu from "./MainMenu";

const Header = () => <div><MainMenu/></div>;


export default Header;